"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PhotoInput = require("./PhotoInput");
Object.keys(_PhotoInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PhotoInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PhotoInput[key];
    }
  });
});